import axios from 'axios'

import { ChanneledRequestParams, Queue } from 'types'

export const getQueues = async (params: ChanneledRequestParams) => {
  return (
    await axios.get<Queue[]>('/queues', {
      params,
    })
  ).data
}
